/* Kanadeal — titre "Explore nos collections" au-dessus du bento NATIF de bannieres.
   Le bento natif (collection-list, layout bento) est deja rendu identiquement sur accueil /
   fiche produit / page collection grace aux CSS scopees `main` (kd-fixes carrousel 85%,
   kd-card-fixes flush image, kd-slider-dots). On NE masque PLUS le natif, on NE reconstruit PLUS
   de copie : on ajoute seulement le titre (pilule + h2) au-dessus, aligne sur les cartes. */
(function(){
  if(window.__kdCollBentoInit) return; window.__kdCollBentoInit=true;
  var HEAD='<div class="kdcb__head"><span class="kdcb__eyebrow">Nos univers CBD</span><h2 class="kdcb__title">Explore nos collections</h2></div>';
  function addHeading(){
    var main=document.querySelector('main[data-template]');
    if(!main) return;
    var t=main.getAttribute('data-template');
    if(t!=='index' && t!=='product' && t!=='collection') return;
    var rail=main.querySelector('.bento-box--items-4') || main.querySelector('.bento-box');
    if(!rail) return;
    var railWrap=rail.closest('.resource-list--bento') || rail;
    var content=railWrap.parentNode; if(!content) return;
    var host=main.querySelector('.kdcb-heading');
    if(!host){ host=document.createElement('div'); host.className='kdcb kdcb-heading'; host.innerHTML=HEAD; }
    if(railWrap.previousElementSibling!==host){ content.insertBefore(host, railWrap); }
  }
  function init(){ addHeading(); [300,900,1800,3000].forEach(function(d){setTimeout(addHeading,d);}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
